module.exports = __webpack_public_path__ + "img/pop-center.ad26e079.png";